<template>
  <div>


    <section class="masthead masthead--inner">
      <div class="in">
        <div class="masthead__slide" style="background: url('../../../../../../static/styles/mailkit/img/banner.jpg') center center / cover no-repeat; width: 100%; display: inline-block;">
          <div class="masthead__caption">
            <h3>Success!<br>Great news{{ quote ? ' ' + quote.user.name : '' }}, we have found the following options for you…</h3>
          </div>
        </div>
      </div>
    </section>

    <div style="text-align:center;" v-show="new_costs && new_costs[0]">
      <div class="in container">
        <h4 class="header-like-para" v-if="quote && !quote.uses_franking_machine && new_costs && new_costs[0] && yourPotentialSavingIs(results.new_costs[0]).postage_savings_over_term > 0">Your Potential Saving is <span v-html="mnwp(Math.abs(yourPotentialSavingIs(results.new_costs[0]).postage_savings_over_term))" style="color:#b50a78 !important"></span></h4>
        <h4 class="header-like-para" v-if="quote && quote.uses_franking_machine && new_costs && new_costs[0] && yourPotentialSavingIs(results.new_costs[0]).savings_over_term > 0">Your Potential Saving is <span v-html="mnwp(Math.abs(yourPotentialSavingIs(results.new_costs[0]).savings_over_term))" style="color:#b50a78 !important"></span></h4>
      </div>
    </div>


    <section class="benefits">
      <div class="in container">
        <div class="cmpreRslt">
          <div class="frmTitle" style="text-align: left;font-weight:600">
            Tailor your requirements:
            <a v-if="quote && quote.office_address" class="btn btn--plain" style="font-size: 0.8em; float: right;">{{ quote ? quote.office_address : '' }}</a>
          </div>
          <div class="frmTitle">
            Desired manufacturer
          </div>

          <div class="mnfctrSlct" style="background-color: #CCC;">
            <div class="formElem__block">
              <div class="inputElem">
                <ul>
                  <li class="manufacturer-toggle"><input type="checkbox" checked @click="toggleManufacturer(2)"/><div></div><img src="/static/styles/mailkit/img/manu1.png"/></li>
                  <li class="manufacturer-toggle"><input type="checkbox" checked @click="toggleManufacturer(3)"/><div></div><img src="/static/styles/mailkit/img/manu2.png"/></li>
                  <li class="manufacturer-toggle"><input type="checkbox" checked @click="toggleManufacturer(4)"/><div></div><img src="/static/styles/mailkit/img/manu3.png"/></li>
                  <li class="manufacturer-toggle"><input type="checkbox" checked @click="toggleManufacturer(5)"/><div></div><img src="/static/styles/mailkit/img/manu4.png"/></li>
                </ul>
              </div>
            </div>
          </div>

          <div class="frmTitle">
            Select your preferred investment options
          </div>

          <div class="prcheOptn" style="padding-top: 0px; display: flex; align-items: center; justify-content: center;">
            <div class="sm:pb-0 frmInline">
              <label style="position: relative;font-size: 1.4rem;line-height: 1.4;color: #363636;top: 4px;margin-right: 15px;">Purchase Option Required</label>
              <span>Yes</span><input type="radio" name="reqpurchse" v-model="additionalOptions.quote_confirmation" :value="true"/>
              <span>No</span><input type="radio" name="reqpurchse" v-model="additionalOptions.quote_confirmation" :value="false"/>
            </div>
          </div>
          <div class="sm:pt-0 lesetrmOptn">
            <div class="frmInline leaseOptionDrops" style="padding-top: 0;">
              <div>
                <div>
                  <span style="display: block; padding:15px 0">Lease Option 1</span>
                </div>
                <div>
                  <select v-model="additionalOptions.lease_option_1">
                    <option :value="1" v-if="additionalOptions.lease_option_2 != 1">1 year</option>
                    <option :value="2" v-if="additionalOptions.lease_option_2 != 2">2 year</option>
                    <option :value="3" v-if="additionalOptions.lease_option_2 != 3">3 year</option>
                    <option :value="4" v-if="additionalOptions.lease_option_2 != 4">4 year</option>
                    <option :value="5" v-if="additionalOptions.lease_option_2 != 5">5 year</option>
                    <option :value="6" v-if="additionalOptions.lease_option_2 != 6">6 year</option>
                  </select>
                </div>
              </div>
              <div>
                <div>
                  <span style="display: block;padding:15px 0">Lease Option 2</span>
                </div>

                <div>
                  <select v-model="additionalOptions.lease_option_2">
                    <option :value="1" v-if="additionalOptions.lease_option_1 != 1">1 year</option>
                    <option :value="2" v-if="additionalOptions.lease_option_1 != 2">2 year</option>
                    <option :value="3" v-if="additionalOptions.lease_option_1 != 3">3 year</option>
                    <option :value="4" v-if="additionalOptions.lease_option_1 != 4">4 year</option>
                    <option :value="5" v-if="additionalOptions.lease_option_1 != 5">5 year</option>
                    <option :value="6" v-if="additionalOptions.lease_option_1 != 6">6 year</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="benefTip">Top tip: The longer the term the larger the savings</div>
          <div class="benefits__forms formElem" v-if="topModal">
            <div class="inputmodal active">
              <div class="in">
                <div class="inputmodal__close">
                  <img src="/static/styles/mailkit/img/multiply.svg"/>
                </div>
                <p>
                  <span v-if="topModal == 1">
                    Manual Feed or Handfeed machines are the entry level franking machines allowing the user to feed and process one letter at a time through the feeder.
                    An Automatic machine allows you to stack up same size and weight items on the feeder for the machine to very quickly process. The user confirms on the machine which postage service is required and the franking machine automatically processes the pile of post, franking all items at the same rate.
                    Fully automatic machines have inline dimension and weighing capabilities allowing the user to stack mixed size and weight items on to the feeder, all the user does is confirm the postal class and the machine will very quickly check the length, width, thickness, depth and weight and frank each letter accordingly with the correct postage rate. This avoids errors, surcharges and prevents risk of embarrassment to clients who receive mail incorrectly processed and subsequently have to collect it from a postage office and often pay for the privilege.
                  </span>
                  <span v-if="topModal == 2">
                    Most franking machines come with the ability to add accounts, this allows you to process items under an account in the franking machine and later report on usage. This helps simplify the cross billing and charging to different departments or cost centres.
                    <b>Important</b> The number of accounts chosen may limit your results as not all manufacturers provide up to 3000 accounts available.
                  </span>
                  <span v-if="topModal == 3">
                    A typical letter weighs around 60g and because of this such we find most businesses only require a 2-3kg scale these days, however options up to 30/35kg still exist on Pitney Bowes and Quadient (Neopost) models.
                    <b>Important</b> Frama only offer linked scales up to 5kg so any weight beyond these will limit your result options to just Pitney Bowes, Quadient (Neopost) and FP.
                  </span>
                  <span v-if="topModal == 4">
                    Engineer installation and training allows for an onsite engineer to support on the setup, installation and training for the use of the new franking solution. Some machines come as standard with engineer installation and training, others are self-install unless you opt for the added service.
                  </span>
                  <span v-if="topModal == 5">
                    The differential weighing feature is a great feature for any business regularly sending a large number of packets/parcels. The operator can stack the items collectively on the scale, choose the appropriate class and under differential mode as an item is removed a label for the item can be printed and applied to that item, this process can then be repeated for all items on the scale speeding up the process of shipping.
                  </span>
                  <span v-if="topModal == 6">
                    Logo and return addresses are available on all machines, however only some provide these free of charge with the machine. Where a logo or return address isn't provided with the machine you have the option to add this at a cost.
                  </span>
                  <span v-if="topModal == 7">
                    Business Mail Advanced is a discounted mail tariff for businesses sending over 250 Letter format (DL/C5) items in any single mailing, discounts are based on items with clean addresses i.e. allowing Royal Mail to read and automatically sort/process mail without manual intervention and in doing so they pass on savings for this automation.
                  </span>
                  <span v-if="topModal == 8">
                    All new mailing machines require a network connection for updates, to transmit postage spend information and for postage top ups/refills. Some models offer the option of wifi connection, 3G connection (via a dongle) or PC meter connect (this utilises a PC with internet connection and some software to allow a connection.
                  </span>
                  <span v-if="topModal == 9">
                    <b>Payment in arrears:</b><br>
                    This service is only available through Pitney Bowes and Quadient (Neopost) at this time. This service allows businesses to top up franking machines, pulling funds from an agreed credit limit. Rather than an invoice for every postage top up/refill a monthly statement covering all transactions during that monthly billing period is instead sent. This service typically carries higher recrediting fees but reduces the number of invoices to one consolidated monthly statement and means your business doesn't have funds tied up and sitting in a holding account. Pitney Bowes payment in arrears service is called Purchase Power. Quadient (Neopost) is called Neofunds.
                    <br><br>
                    <b>Payment in advance</b><br>
                    The payment in advance services are available from all manufacturers and require your business to prepay into a deposit/holding account. When your franking machine is refilled/topped up funds will be drawn down from your account. For each top up/refill transaction your business will be invoiced for each transaction, plus any associated reset/recrediting charges. On payment of this invoice your holding/deposit account is replenished to the agreed balance ensuring you have suitable funds available for when you next need to top up.
                  </span>
                  <span v-if="topModal == 10">
                    This technology is only available from Pitney Bowes and provides the abilty to add a barcode scanner to the franking machine. This then allows the users to scan the barcode on items received, input the intended recipient, send an email notification to the recipient confirming an item has been received for them before the team print a delivery manifest on a connected printed (not supplied) and take to the recipient to sign on delivery. Future upgrade options are available to allow delivery and signature capture via WiFi or 3g connected PDAs.
                  </span>
                  <span v-if="topModal == 11">
                    This technology allows users to rate shop for recorded, special delivery 1pms and parcel/packets for shipping. The kit provides the license, a shipping label printer and 30kg scale for PC connection. A user can then save regular recipients they send to whilst also entering the email of the sender and recipient to provide tracking information automatically on posting.
                  </span>
                  <span v-if="topModal == 12">
                    Quadient (Neopost) and FP (Francotyp Postalia) offer enhanced service maintenance options. Enhanced service options provide an expedited resolution to any machine issues vs the manufacturers standard service maintenance options. They come at a premium but if processing your post is critical to your business it is worth considering. A more appropriate consideration is often a small secondary device as this would offer true contingency at a low cost whilst supporting your business at peak times.
                  </span>
                  <span class="modelClose" @click="topModal = null">(X)</span></p>
              </div>
            </div>
          </div>

          <div style="margin-top:10px; margin-bottom:10px; padding-left:10px; width:100%;">
            <div class="results-advanced-options-button">
              <span @click="additionalOptionsOpen = !additionalOptionsOpen">
              Advanced options
              <i class="fa fa-chevron-right" v-if="!additionalOptionsOpen"></i>
              <i class="fa fa-chevron-down" v-if="additionalOptionsOpen"></i>
            </span>
            </div>
            <div class="results-reset-options-button">
              <div @click="resetFilters()">Reset Options</div>
            </div>
            <div style="clear:both;"></div>
          </div>
          <div class="benefits__forms formElem" v-if="additionalOptionsOpen">

            <div class="formElem__block">
              <div class="inputLabel">
                <div class="infoIcon" @click="topModal = 1"> i </div>
                feeder type
              </div>
              <div class="inputElem">
                <select v-model="additionalOptions.feeder_type">
                  <option selected :value="null">Please Select</option>
                  <option value="hand">Hand feeder</option>
                  <option value="auto">Automatic feeder</option>
                  <option value="full_auto">Fully automatic feeder</option>
                </select>
              </div>
            </div>
            <div class="formElem__block">
              <div class="inputLabel">
                <div class="infoIcon" @click="topModal = 2"> i </div>
                Departmental accounting
              </div>
              <div class="inputElem">
                <select v-model="additionalOptions.accounts_amount">
                  <option selected :value="null">Please Select</option>
                  <option :value="9">Up to 9</option>
                  <option :value="10">Up to 10</option>
                  <option :value="25">Up to 25</option>
                  <option :value="30">Up to 30</option>
                  <option :value="35">Up to 35</option>
                  <option :value="50">Up to 50</option>
                  <option :value="100">Up to 100</option>
                  <option :value="150">Up to 150</option>
                  <option :value="200">Up to 200</option>
                  <option :value="300">Up to 300</option>
                  <option :value="500">Up to 500</option>
                  <option :value="1000">Up to 1000</option>
                  <option :value="2000">Up to 2000</option>
                  <option :value="3000">Up to 3000</option>
                </select>
              </div>
            </div>
            <div class="formElem__block">
              <div class="inputLabel">
                <div class="infoIcon" @click="topModal = 3"> i </div>
                scale size
              </div>
              <div class="inputElem">
                <select v-model="additionalOptions.packets_capacity">
                  <option selected="" :value="null">Please Select</option>
                  <option value="2_3">2 - 3 KG</option>
                  <option value="5">5 KG</option>
                  <option value="7">7 KG</option>
                  <option value="10_12">10 - 12 KG</option>
                  <option value="30_35">30 - 35 KG</option>
                </select>
              </div>
            </div>
            <div class="formElem__block">
              <div class="inputLabel">
                <div class="infoIcon" @click="topModal = 4"> i </div>
                install & training
              </div>
              <div class="inputElem">
                <select v-model="additionalOptions.engineer_installation_training">
                  <option selected="" :value="null">Please Select</option>
                  <option :value="'add'">Add</option>
                  <option :value="false">Don't add</option>
                </select>
              </div>
            </div>


            <div class="formElem__block">
              <div class="inputLabel">
                <div class="infoIcon" @click="topModal = 5"> i </div>
                Differential weighting
              </div>
              <div class="inputElem">
                <select class="option-select" v-model="additionalOptions.differential_weighting">
                  <option :value="null">Please select</option>
                  <option value="add">Add</option>
                  <option :value="false">Don't add</option>
                </select>
              </div>
            </div>

            <div class="formElem__block">
              <div class="inputLabel">
                <div class="infoIcon" @click="topModal = 6"> i </div>
                Custom Logo/Return Address Included with New Machine
              </div>
              <div class="inputElem">
                <!--v-if="model.return_address_included_with_machine === 'Not included (available at additional cost)'-->
                <select class="option-select" v-model="additionalOptions.logo_and_return_address">
                  <option :value="null">Please select</option>
                  <option value="add">Add</option>
                  <option :value="false">Don't add</option>
                </select>
              </div>
            </div>
            <div class="formElem__block">
              <div class="inputLabel">
                <div class="infoIcon" @click="topModal = 7"> i </div>
                Business mail advanced
              </div>
              <div class="inputElem">
                <!--v-if="model.business_mail_advanced.includes('included')"-->
                <select class="option-select" v-model="additionalOptions.business_mail_advanced">
                  <option :value="null">Please select</option>
                  <option value="add">Add</option>
                  <option :value="false">Don't add</option>
                </select>
              </div>
            </div>
            <div class="formElem__block">
              <div class="inputLabel">
                <div class="infoIcon" @click="topModal = 8"> i </div>
                Connectivity kit options
              </div>
              <div class="inputElem">
                <!--v-if="model.connectivity.includes('3G') || model.connectivity.includes('WIFI')"-->
                <select class="option-select" v-model="additionalOptions.connectivity">
                  <option :value="null">Please select</option>
                  <option value="3g">3G</option>
                  <option value="wifi">Wi-Fi</option>
                </select>
              </div>
            </div>
            <div class="formElem__block">
              <div class="inputLabel">
                <div class="infoIcon" @click="topModal = 9"> i </div>
                Postage payment
              </div>
              <div class="inputElem">
                <select class="option-select" v-model="additionalOptions.postage_payment">
                  <option :value="null">Please select</option>
                  <option value="advanced">Advance</option>
                  <option value="arrears">Arrears</option>
                </select>
              </div>
            </div>
            <div class="formElem__block">
              <div class="inputLabel">
                <div class="infoIcon" @click="topModal = 10"> i </div>
                Barcode Scanner Peripherals
              </div>
              <div class="inputElem">
                <!--v-if="model.integrated_internal_mail_tracking_app.includes('Included')"-->
                <select class="option-select" v-model="additionalOptions.inbound_courier_parcel_tracking_cost">
                  <option :value="null">Please select</option>
                  <option value="add">Add barcode scanner</option>
                  <option :value="false">Don't add</option>
                </select>
              </div>
            </div>
            <div class="formElem__block">
              <div class="inputLabel">
                <div class="infoIcon" @click="topModal = 11"> i </div>
                Outbound shipping application
              </div>
              <select class="option-select" v-model="additionalOptions.outbound_shipping_application">
                <option :value="null">Please select</option>
                <option value="add">Add</option>
                <option :value="false">Don't add</option>
              </select>
            </div>
            <div class="formElem__block">
              <div class="inputLabel">
                <div class="infoIcon" @click="topModal = 12"> i </div>
                Service / maintenance offering
              </div>
              <select class="option-select" v-model="additionalOptions.service_upgrade">
                <option :value="null">Please select</option>
                <option value="standard" v-if="!(quote.postage_payment === 'arrears' && quote.postage_spend_custom > 10000)">Standard</option>
                <option value="enhanced">Enhanced</option>
              </select>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="results desktop">
      <div class="in container">
        <div class="results__table" v-if="new_costs" style="overflow: visible !important;">
          <table>
            <tr>
              <td class="noStyle"></td>
              <td colspan="8" class="locationRow">
                <div>
                  <h5>Your Quote Options</h5>
                </div>
              </td>
            </tr>
            <tr>
              <th class="noStyle"></th>
              <th class="large">Manufacturer and model</th>
              <th>Speed (letters/minute)  </th>
              <th>Envelope thickness capacity</th>
              <th>Scale capacity</th>
              <th>Service offering</th>
              <th>Product rating</th>
              <th v-show="!quote.uses_franking_machine">Best Quarterly Lease Option</th>
              <th v-show="quote.uses_franking_machine">Your potential savings</th>
              <th>Features explained</th>
            </tr>
            <tbody>
            <tr>
              <td class='rotate blue' rowspan="1">
                <div style="font-size:25px;">Current</div>
              </td>
              <td class="image">
                <img :src="printerImage(current_costs.printer.image_url)" v-if='current_costs && current_costs.printer' :class="{'stamps' : current_costs.printer.id == 1}"/>
                <div>
                  {{ current_costs && current_costs.printer ? current_costs.printer.manufacturer.name : ''}}
                  <br/>
                  {{ current_costs && current_costs.printer ? current_costs.printer.model : '' }}
                </div>
              </td>
              <td class="innerTable">
                <table>
                  <tr>
                    <td>
                      <h6>Standard</h6>
                      {{ current_costs && current_costs.printer ? current_costs.printer.speed_standard : 0 }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6>Auto size and weight</h6>
                      {{ current_costs && current_costs.printer ? current_costs.printer.auto_size_weight : 0 }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>{{ current_costs && current_costs.printer ? current_costs.printer.envelope_thickness_capacity : 0 }} mm</td>
              <td>{{ current_costs && current_costs.printer ? current_costs.printer.scale_capacity : 0 }} kg</td>
              <td v-if="(current_costs && current_costs.printer) && current_costs.printer.model === 'Stamps'" style="font-size:1.8rem;font-weight:400">N/A</td>
              <td v-else>AS PER EXISTING</td>
              <td>
                <rating-view :rating="current_costs ? current_costs.rating : 0" :max="results ? results.max_rating : 0"></rating-view>
              </td>

              <td class="largeText" style="font-size:1.8rem;font-weight:400">N/A</td>
              <td class="largeText" style="font-size:1.8rem;font-weight:400">N/A</td>
            </tr>

            <tr>
              <td colspan="9" style="height: 10px; background-color: #F4F4F4"></td>
            </tr>

            <fragment v-for="costs, index in new_costs" v-if="new_costs && enabledManufacturers[costs.manufacturer.id] === true" :key="index">

              <tr v-if="costsHasError(costs)">
                <td class='rotate grey' t="t1">
                  <div style="font-size:25px;" v-show="!costsHasError(costs)">Proposed</div>
                </td>
                <td class="image">
                  <img :src="'/static/styles/mailkit/img/manu' + (costs.manufacturer.id - 1) + '.png'"/>
                </td>
                <td colspan="8" style="text-transform:none">
                  <div style="display: flex; align-items: center; justify-content:center;">
                    <img src="/static/styles/mailkit/img/warning.png" alt="">
                    <div>
                      <span class="red-text">{{ costs.manufacturer.name }} option not available due to:</span>
                      <div class="red-text" v-if="!costs.feeder_type_not_found && costs.scale_cost_machine_not_found"> - {{ additionalOptions.packets_capacity.replace('_', ' - ') }}kg Scale size not available</div>
                      <div class="red-text" v-if="costs.departmental_accounting_not_found"> - {{ additionalOptions.accounts_amount }} accounts not available</div>
                      <div class="red-text" v-if="costs.postage_payment_arrears_warning"> - Arrears postage account not available</div>
                      <div class="red-text" v-if="costs.differential_weighting_not_found"> - Differential weighting is not available</div>
                      <div class="red-text" v-if="costs.business_mail_advanced_not_found"> - Business mail advanced is not available</div>
                      <div class="red-text" v-if="costs.connectivity_not_found"> - {{ additionalOptions.connectivity }} connectivity option is not available</div>
                      <div class="red-text" v-if="costs.inbound_courier_parcel_tracking_cost_not_found"> - Barcode scanner peripherals are not available</div>
                      <div class="red-text" v-if="costs.outbound_shipping_application_not_found"> - Outbound shipping application is not available</div>
                      <div class="red-text" v-if="costs.service_upgrade_not_found"> - Service upgrade is not available</div>
                      <div class="red-text" v-if="costs.comparable_model_not_found"> - No comparable model available</div>
                      <div class="red-text" v-if="costs.feeder_type_not_found"> - {{ getReadableFeederType(additionalOptions.feeder_type) }} not available;</div>
                      <div class="red-text" v-if="costs.machine_not_found">Can't find a machine that fits the requirements</div>
                    </div>
                  </div>

                  <div class="blue-text">If your requirements are flexible, try tailoring your options to pull more results</div>
                </td>
              </tr>

              <tr v-if="!costsHasError(costs)">
                <td class='rotate red' rowspan="1" t="t2">
                  <div style="font-size:25px;">Proposed</div>
                </td>
                <td rowspan="1" class="image">
                  <img :src="printerImage(costs.printer.image_url)" v-if='costs.printer'/>
                  {{ costs.printer ? costs.printer.manufacturer.name : '' }}
                  <br/>
                  {{ costs.printer ? costs.printer.model : '' }}
                </td>
                <td class="innerTable">
                  <table>
                    <tr>
                      <td>
                        <h6>Standard</h6>
                        {{ costs.printer ? costs.printer.speed_standard : 0 }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h6>Auto size and weight</h6>
                        {{ costs.printer ? costs.printer.auto_size_weight : 0 }}
                      </td>
                    </tr>
                  </table>
                </td>
                <td>{{ costs.printer ? costs.printer.envelope_thickness_capacity : 0 }} mm</td>
                <td>
                  {{additionalOptions.packets_capacity.replace('_','-')}} kg
                </td>
                <td v-if="quote.service_upgrade === 'enhanced'">
                  <span v-if="costs.printer.manufacturer_id === 4">swapit+</span>
                  <span v-if="costs.printer.manufacturer_id === 3">total care</span>
                </td>
                <td v-else-if="costs.postage_recredit_costs_updated_to_total_care">
                  TOTAL CARE
                </td>
                <td v-else>
                  {{ costs.printer ? costs.printer.service_name : '-' }}
                </td>
                <td>
                  <rating-view :rating="costs.printer ? costs.rating : 0" :max="results ? results.max_rating : 0"></rating-view>
                </td>
                <td class="largeText red" style="color: #b50a78 !important;">
                  <span v-if="quote.uses_franking_machine"
                    style="white-space: nowrap;font-size:1.8rem;font-weight:400"
                    v-html="costs && yourPotentialSavingIs(costs).savings_over_term > 0 ? mnwp(Math.abs(yourPotentialSavingIs(costs).savings_over_term)) : 'N/A'"></span>

                  <span v-if="!quote.uses_franking_machine"
                        style="white-space: nowrap;font-size:1.8rem;font-weight:400"
                        v-html="costs.costQuarterlyLease > 0 ? mnwp(Math.abs(costs.costQuarterlyLease)) : 'N/A'"></span>
                </td>
                <td>
                  <a href="#" class="btn btn-gradient" style="border: none; padding: 10px 20px; border-radius: 10px" @click.prevent="toggleMoreInfo(index)"><span style="font-weight:700">View Quote Details</span></a>
                </td>
              </tr>

              <more-info-tr
                @progress-with-order="(investment_option) => onProgressWithOrder(investment_option, quote, costs, additionalOptions, current_costs)"
                :quote="quote"
                :new_costs="costs"
                :current_costs="current_costs"
                :model="costs.printer"
                :service_upgrade="additionalOptions.service_upgrade"
                :quote_confirmation="additionalOptions.quote_confirmation"
                :additionalOptions="additionalOptions"
                v-if="!costsHasError(costs) && showMoreInfo === index && costs.printer"></more-info-tr>
              <!--<tr class="fullWidth">-->
              <!--<td class="noStyle"></td>-->
              <!--<td class="preferred" colspan="7">this is my preferred model</td>-->
              <!--</tr>-->

              <tr>
                <td colspan="9" style="height: 10px; background-color: #F4F4F4"></td>
              </tr>


            </fragment>

            </tbody>
          </table>
        </div>
      </div>
    </section>

    <section class="results-mobile" v-if="new_costs">
      <div class="in container">

        <!-- potential-savings -->
        <!--<div class="potential-savings">
          your potential savings <span v-if="quote.machines_amount > 1">when opting for full fleet:</span><br> <span v-html="new_costs && new_costs[0] ? mnwp(maxSavingOverTerm(results.new_costs[0])) : 'N/A'"></span>
        </div>-->

        <!-- location -->
        <div class="location">
          <strong>Your Quote Options</strong>
        </div>

        <!-- current solution -->
        <div class="offer first">
          <strong class="offer-title blue">Current Solution</strong>

          <table class="offer-table">
            <tr>
              <th class="big">Manufacturer and model</th>
              <th>Speed<br> (letters/min)</th>
              <th>Envelope thickness</th>
              <th>Standard scale capacity</th>
            </tr>
            <tr>
              <td class="image">
                <img :src="printerImage(current_costs.printer.image_url)" v-if='current_costs && current_costs.printer' :class="{'stamps' : current_costs.printer.id == 1}">
                {{ current_costs && current_costs.printer ? current_costs.printer.manufacturer.name : ''}}<br>
                {{ current_costs && current_costs.printer ? current_costs.printer.model : '' }}
              </td>
              <td>
                <strong>standard</strong><br>
                {{ current_costs && current_costs.printer ? current_costs.printer.speed_standard : 0 }}

                <div class="separator"></div>

                <strong>Auto size<br> and weight</strong><br>
                {{ current_costs && current_costs.printer ? current_costs.printer.auto_size_weight : 0 }}
              </td>
              <td>{{ current_costs && current_costs.printer ? current_costs.printer.envelope_thickness_capacity : 0 }} mm</td>
              <td>{{ current_costs && current_costs.printer ? current_costs.printer.scale_capacity : 0 }} kg</td>
            </tr>
            <tr>
              <th>Service offering</th>
              <th>Product rating</th>
              <th>Your potential savings</th>
              <th>Features explained</th>
            </tr>
            <tr>
              <td>
                {{ current_costs && current_costs.printer ? current_costs.printer.service_name : '-' }}
              </td>
              <td>
                <rating-view :rating="current_costs ? current_costs.rating : 0" :max="results ? results.max_rating : 0"></rating-view>
              </td>
              <td class="largeText" style="font-size:1.8rem;font-weight:400">N/A</td>
              <td class="largeText" style="font-size:1.8rem;font-weight:400">N/A</td>
            </tr>
          </table>
        </div>

        <!-- proposed solutions -->
        <fragment v-for="costs, index in new_costs" v-if="new_costs && enabledManufacturers[costs.manufacturer.id] === true" :key="index">
          <div class="offer">
            <strong class="offer-title red">Proposed Solution</strong>

            <div class="offer-errors" v-if="costsHasError(costs)">
              <img :src="'/static/styles/mailkit/img/manu' + (costs.manufacturer.id - 1) + '.png'" class="manufacturer-logo">

              <div class="warning">
                <img src="/static/styles/mailkit/img/warning.png">
                <div>
                  <div class="red-text">{{ costs.manufacturer.name }} option not available due to:</div>
                  <div class="red-text" v-if="!costs.feeder_type_not_found && costs.scale_cost_machine_not_found"> - {{ additionalOptions.packets_capacity.replace('_', ' - ') }}kg scale size not available</div>
                  <div class="red-text" v-if="costs.departmental_accounting_not_found"> - {{ additionalOptions.accounts_amount }} accounts not available</div>
                  <div class="red-text" v-if="costs.postage_payment_arrears_warning"> - Arrears postage account not available</div>
                  <div class="red-text" v-if="costs.differential_weighting_not_found"> - Differential weighting is not available</div>
                  <div class="red-text" v-if="costs.business_mail_advanced_not_found"> - Business mail advanced is not available</div>
                  <div class="red-text" v-if="costs.connectivity_not_found"> - {{ additionalOptions.connectivity }} connectivity option is not available</div>
                  <div class="red-text" v-if="costs.inbound_courier_parcel_tracking_cost_not_found"> - Barcode scanner periphials are not available</div>
                  <div class="red-text" v-if="costs.outbound_shipping_application_not_found"> - Outbound shipping application is not available</div>
                  <div class="red-text" v-if="costs.service_upgrade_not_found"> - Service upgrade is not available</div>
                  <div class="red-text" v-if="costs.comparable_model_not_found"> - No comparable model available</div>
                  <div class="red-text" v-if="costs.feeder_type_not_found"> - {{ getReadableFeederType(additionalOptions.feeder_type) }} not available;</div>
                  <div class="red-text" v-if="costs.machine_not_found">Can't find a machine that fits the requirements</div>
                </div>
              </div>

              <div class="blue-text">If your requirements are flexible, try tailoring your options to pull more results</div>
            </div>

            <table class="offer-table" v-if="!costsHasError(costs)">
              <tr>
                <th class="big" style="width:50%"><span>manufacturer and model:</span><br><span style="font-weight:500">{{ costs.printer ? costs.printer.manufacturer.name : '' }} {{ costs.printer ? costs.printer.model : '' }}</span></th>
                <th style="width:50%"><span>Service offering</span><br><span style="font-weight:500">{{ costs.printer ? costs.printer.service_name : '-' }}</span></th>
              </tr>
              <tr>
                <td class="image">
                  <img :src="printerImage(costs.printer.image_url)" v-if='costs.printer'>
                </td>
                <td>
                  <span>Your potential savings</span><br>
                  <span
                    style="white-space: nowrap;font-size:1.8rem;font-weight:400;color:#b50a78"
                    v-html="costs && yourPotentialSavingIs(costs).savings_over_term > 0 ? mnwp(Math.abs(yourPotentialSavingIs(costs).savings_over_term)) : 'N/A'"></span>
                  <!--<strong v-html="costs ? mnwp(maxSavingOverTerm(costs)) : 'N/A'"></strong>-->
                  <div class="offer-buttons" v-if="!costsHasError(costs)">
                    <a href="#" class="red" @click.prevent="toggleMoreInfo(index)" style="font-size: 1.2rem;margin:0 10px;padding:7px 10px">View Quote Details</a>
                  </div>
                </td>
              </tr>
            </table>

            <table class="offer-table" v-if="!costsHasError(costs)">
              <tr>
                <td>
                  <span style="font-weight:600;text-align: left;padding-left:10px">Key machine specification:</span>
                </td>
              </tr>
            </table>

            <table class="offer-table" v-if="!costsHasError(costs)">
              <tr>
                <th style="width:25%;border-top:1px solid #ccc">Speed<br> (letters/min)</th>
                <th style="width:25%;border-top:1px solid #ccc">Envelope thickness</th>
                <th style="width:25%;border-top:1px solid #ccc">Scale capacity</th>
                <th style="width:25%;border-top:1px solid #ccc;border-right:1px solid #ccc">Product rating</th>
              </tr>
              <tr>
                <td>
                  <strong>standard</strong><br>
                  {{ costs.printer ? costs.printer.speed_standard : 0 }}

                  <div class="separator"></div>

                  <strong>Auto size<br> and weight</strong><br>
                  {{ costs.printer ? costs.printer.auto_size_weight : 0 }}
                </td>
                <td>{{ costs.printer ? costs.printer.envelope_thickness_capacity : 0 }} mm</td>
                <td>{{ costs.printer ? costs.printer.scale_capacity : 0 }} kg</td>
                <td style="border-right: 1px solid #ccc">
                  <rating-view :rating="costs.printer ? costs.rating : 0" :max="results ? results.max_rating : 0"></rating-view>
                </td>
              </tr>
            </table>

            <div class="offer-info-wrapper" v-if="!costsHasError(costs) && (costs.scale_cost_warning || costs.departmental_accounting_warning || costs.postage_recredit_costs_warning_for_pb || costs.scale_cost_machine_upgraded || costs.departmental_accounting_machine_upgraded)">
              <!--<div v-if="costs.scale_cost_warning || costs.departmental_accounting_warning" class="offer-info">-->
              <!--<img src="/static/styles/mailkit/img/warning.png" alt="">-->
              <!--<span>This model is a closest match available on the information provided</span>-->
              <!--</div>-->

              <div v-if="costs.postage_recredit_costs_warning_for_pb" class="offer-info">
                <img src="/static/styles/mailkit/img/warning.png" alt="">
                <span>'Enhanced Service Level' not available on this option</span>
              </div>

              <div v-if="costs.scale_cost_machine_upgraded" class="offer-info">
                <img src="/static/styles/mailkit/img/warning-green.png" alt="">
                <span>THIS MACHINE HAS BEEN UPGRADED TO ACCOMMODATE YOUR SCALE REQUIREMENT</span>
              </div>

              <div v-if="costs.departmental_accounting_machine_upgraded" class="offer-info">
                <img src="/static/styles/mailkit/img/warning-green.png" alt="">
                <span>This machine has had to be upgraded to accommodate your departmental account requirements</span>
              </div>
            </div>
          </div>

          <section class="results more-info" v-if="!costsHasError(costs) && showMoreInfo === index && costs.printer">
            <div class="results__table">
              <table>
                <more-info-tr
                  @progress-with-order="(investment_option) => onProgressWithOrder(investment_option, quote, costs, additionalOptions, current_costs)"
                  :quote="quote"
                  :new_costs="costs"
                  :current_costs="current_costs"
                  :model="costs.printer"
                  :service_upgrade="additionalOptions.service_upgrade"
                  :quote_confirmation="additionalOptions.quote_confirmation"
                  :additionalOptions="additionalOptions"></more-info-tr>
              </table>
            </div>
          </section>
        </fragment>

      </div>
    </section>

    <section class="contactCta">
      <div class="in container">
        <div class="contactCta__block">
          <div class="in">
            <h3>Need to speak with us direct?
              <br>Call us today <a href="tel:0330 124 1977">0330 124 1977</a></h3>
          </div>
        </div>
      </div>
    </section>

    <quote-info :quote="quote" :results='results' v-if="_showDebug" :quote_confirmation="additionalOptions.quote_confirmation"></quote-info>

  </div>
</template>
<script>
  import MoreInfo from './MoreInfo.vue'
  import QuoteInfo from './../Debug/QuoteInfo.vue'
  import RatingView from './Rating.vue'

  export default {
    components: {
      'more-info-tr': MoreInfo,
      QuoteInfo,
      RatingView,
    },
    created() {
      this.quote_id = this.$route.params.quote_id
      this.loadResults()
      document.body.classList.remove('has-table')
    },
    computed: {
      _showDebug() {
        return this.$store.getters['auth/authCheck'] && this.quote && this.$store.getters['auth/user'] && this.$store.getters["auth/user"].data.preferences.is_admin
      }
    },

    data() {
      return {
        yourPotentialSavingPositive: false,

        showMoreInfo: null,
        showMoreInfoCache: null,
        loading: true,
        quote_id: null,
        quote: null,
        additionalOptionsOpen: false,
        results: {
          table1: {},
          letters: null,
          packets: null,
          total: null,
          models: {},
          printer_model: null,
        },
        new_costs: null,
        current_costs: null,
        watchAdditionalOptions: true,
        additionalOptions: {
          lease_option_1: null,
          lease_option_2: null,
          quote_confirmation: null,
          packets_capacity: null,
          accounts_amount: null,
          feeder_type: null,
          engineer_installation_training: null,
          differential_weighting: null,
          logo_and_return_address: null,
          business_mail_advanced: null,
          connectivity: null,
          postage_payment: null,
          inbound_courier_parcel_tracking_cost: null,
          outbound_shipping_application: null,
          service_upgrade: null,
        },
        singlePrinterOptions: {},
        topModal: null,
        enabledManufacturers: {
          2: true,
          3: true,
          4: true,
          5: true,
        }

      }
    },
    watch: {
      additionalOptions: {
        handler() {
          if (this.watchAdditionalOptions) {
            this.cacheShowMoreInfo()
            this.loadResults()
          }
          this.watchAdditionalOptions = true
        },
        deep: true
      }
    },
    methods: {
      costsHasError(costs) {
        if (costs.postage_payment_arrears_warning) return true
        if (costs.departmental_accounting_not_found) return true
        if (costs.scale_cost_machine_not_found) return true
        if (costs.differential_weighting_not_found) return true
        if (costs.business_mail_advanced_not_found) return true
        if (costs.connectivity_not_found) return true
        if (costs.inbound_courier_parcel_tracking_cost_not_found) return true
        if (costs.outbound_shipping_application_not_found) return true
        if (costs.service_upgrade_not_found) return true
        if (costs.comparable_model_not_found) return true
        if (costs.feeder_type_not_found) return true
        if (costs.machine_not_found) return true
        return false
      },
      loadResults(ignoreAdditionalOptions = false) {

        if (localStorage.getItem('came-from-order')) {
          let additional_options = localStorage.getItem('additional_options')
          if (additional_options) {
            this.additionalOptions = additional_options
            localStorage.removeItem('additional_options')
            localStorage.removeItem('came-from-order')
          }
        }

        let params = {};
        if (!ignoreAdditionalOptions) {
          params = {
            additionalOptions: this.additionalOptions,
            singlePrinterOptions: this.singlePrinterOptions,
          }
        }

        this.axios.get('/quotes/results/' + this.quote_id, {params}).then(response => {
          this.new_costs = false
          this.$nextTick(() => {
            this.$store.commit('QuoteOptions/clearOptions')

            this.results = response.data.results;
            this.current_costs = response.data.results.current_costs;
            this.new_costs = response.data.results.new_costs;
            this.loading = false;
            this.quote = response.data.results.quote;

            this.showMoreInfo = this.showMoreInfoCache || this.showMoreInfoCache === 0 ? this.showMoreInfoCache : null;
            this.showMoreInfoCache = null;

            this.watchAdditionalOptions = false;
            this.additionalOptions = response.data.additionalOptions || {};

            this.yourPotentialSavingPositive = this.maxSavingOverTerm(this.results.new_costs[0]) > 0;

            this.new_costs.forEach(newCost => {
              newCost.costPotentialSaving = this.yourPotentialSavingIs(newCost).savings_over_term

              let options = []
              options.push({
                lease_investment: this.getTotalEffectiveCostValue(newCost, this.additionalOptions.lease_option_1 - 1),
                total_investment: newCost.total_effective_cost.lease[this.additionalOptions.lease_option_1 - 1],
                years: this.additionalOptions.lease_option_1,
                switch_and_save: newCost.switch_and_save.lease[this.additionalOptions.lease_option_1 - 1],
                savings_over_term: newCost.savings_over_term.lease[this.additionalOptions.lease_option_1 - 1],
                postage_savings_over_term: newCost.postage_savings_over_term.lease[this.additionalOptions.lease_option_1 - 1],
              })
              options.push({
                lease_investment: this.getTotalEffectiveCostValue(newCost, this.additionalOptions.lease_option_2 - 1),
                total_investment: newCost.total_effective_cost.lease[this.additionalOptions.lease_option_2 - 1],
                years: this.additionalOptions.lease_option_2,
                switch_and_save: newCost.switch_and_save.lease[this.additionalOptions.lease_option_2 - 1],
                savings_over_term: newCost.savings_over_term.lease[this.additionalOptions.lease_option_2 - 1],
                postage_savings_over_term: newCost.postage_savings_over_term.lease[this.additionalOptions.lease_option_2 - 1],
              })
              if (this.additionalOptions.quote_confirmation) {
                options.push({
                  total_investment: newCost.total_effective_cost.purchase,
                  years: false,
                  switch_and_save: newCost.switch_and_save.purchase,
                  savings_over_term: newCost.savings_over_term.purchase,
                  postage_savings_over_term: newCost.postage_savings_over_term.purchase,
                })
              }

              newCost.options = options
              newCost.costQuarterlyLease = options.sort(function (a, b) {
                return b.lease_investment - a.lease_investment
              })[1].lease_investment

              this.$store.commit('QuoteOptions/setOption', {
                newCost
              })
            })

            this.new_costs.sort((a, b) => (a.costPotentialSaving > b.costPotentialSaving) ? -1 : 1)
          })
        }).catch(err => {
        })
      },
      toggleMoreInfo(id) {
        let valueToShow = this.showMoreInfo === id ? null : id
        this.showMoreInfo = null
        this.$nextTick(() => {
          this.showMoreInfo = valueToShow
        })
      },
      toggleManufacturer(id) {
        let new_costs_temp = {}
        Object.assign(new_costs_temp, this.new_costs)
        this.new_costs = false
        this.showMoreInfo = null
        this.$nextTick(() => {
          this.enabledManufacturers[id] = !this.enabledManufacturers[id]
          this.new_costs = new_costs_temp
          this.showMoreInfo = null
        })
      },

      printerImage(image_url = false) {
        if (image_url)
          return '/static/styles/mailkit/img/printers/' + image_url
        return 'http://placehold.it/195x195'
      },
      cacheShowMoreInfo() {
        this.showMoreInfoCache = this.showMoreInfo
      },

      resetFilters() {
        this.cacheShowMoreInfo()
        this.loadResults(true)
      },

      onProgressWithOrder(investment_option, quote, costs, additional_options, current_costs) {

        this.axios.post('orders', {investment_option, quote, costs, additional_options, current_costs}).then(response => {
          let order_id = response.data.uniqid
          localStorage.setItem('additional_options', JSON.stringify(additional_options))
          this.$router.push({name: 'orders.index', params: {id: order_id}})
        }).catch(err => {
          console.log(err)
        })
      },

      yourPotentialSavingIs(costs) {
        if (!costs.total_effective_cost) { return false }
        let options = [];
        options.push({
          total_investment: costs.total_effective_cost.lease[this.additionalOptions.lease_option_1 - 1],
          years: this.additionalOptions.lease_option_1,
          switch_and_save: costs.switch_and_save.lease[this.additionalOptions.lease_option_1 - 1],
          savings_over_term: costs.savings_over_term.lease[this.additionalOptions.lease_option_1 - 1],
          postage_savings_over_term: costs.postage_savings_over_term.lease[this.additionalOptions.lease_option_1 - 1],
        })
        options.push({
          total_investment: costs.total_effective_cost.lease[this.additionalOptions.lease_option_2 - 1],
          years: this.additionalOptions.lease_option_2,
          switch_and_save: costs.switch_and_save.lease[this.additionalOptions.lease_option_2 - 1],
          savings_over_term: costs.savings_over_term.lease[this.additionalOptions.lease_option_2 - 1],
          postage_savings_over_term: costs.postage_savings_over_term.lease[this.additionalOptions.lease_option_2 - 1],
        })
        if (this.additionalOptions.quote_confirmation) {
          options.push({
            total_investment: costs.total_effective_cost.purchase,
            years: false,
            switch_and_save: costs.switch_and_save.purchase,
            savings_over_term: costs.savings_over_term.purchase,
            postage_savings_over_term: costs.postage_savings_over_term.purchase,
          })
        }

        let option = options.sort(function (a, b) {
            return b.savings_over_term - a.savings_over_term
        })[0]

        return option
      },

      mnwp(number) {
        if (number < 0) {
          return '-&pound;' + _n(Math.abs(number))
        }
        return '&pound;' + _n(number)
      },
      maxSavingOverTerm(costs) {
        if (!costs.effective_annual_saving) { return false; }
        let options = [
          parseFloat(costs.effective_annual_saving.lease[this.additionalOptions.lease_option_1 - 1]).toFixed(2),
          parseFloat(costs.effective_annual_saving.lease[this.additionalOptions.lease_option_2 - 1]).toFixed(2),
        ]
        if (this.additionalOptions.quote_confirmation) {
          options.push(
            parseFloat(costs.effective_annual_saving.purchase).toFixed(2)
          )
        }
        return options.sort((a, b) => {
          return parseFloat(b) - parseFloat(a)
        })[0]
      },

      getReadableFeederType(type) {
        if (type === 'hand') return 'Hand feeder'
        if (type === 'auto') return 'Automatic feeder'
        if (type === 'full_auto') return 'Fully automatic feeder'
      },

      getTotalEffectiveCostValue(costs, years = -1) {
        let value;
        if (years === -1) {
          // Purchase

          // If franking user, pull from C64 (total_cost_future_ownership). Else use C52 (total_equipment_and_service_cost)
          if (this.quote.uses_franking_machine) {
            // Franking machine YES
            if (costs.annual_savings_available.purchase < 0) { // C54 is NEGATIVE
              value = costs.total_equipment_and_service_cost.purchase // use C52
            } else {
              value = costs.total_cost_future_ownership.purchase // use C64
            }
          } else {
            // Franking machine NO
            value = costs.total_equipment_and_service_cost.purchase
          }

        } else {
          // Lease

          // If franking user, pull from C64 (total_cost_future_ownership). Else use C52 (total_equipment_and_service_cost)
          if (this.quote.uses_franking_machine) {
            // Franking machine YES
            if (costs.annual_savings_available.lease[years] < 0) { // C54 is NEGATIVE
              value = costs.total_equipment_and_service_cost.lease[years] // use C52
            } else {
              value = costs.total_cost_future_ownership.lease[years] // use C64
            }
          } else {
            // Franking machine NO
            value = costs.total_equipment_and_service_cost.lease[years] // use C52
          }
        }

        return value ? parseFloat(value) : 0
      },

    }
  }
</script>
<style lang="scss">
@media (max-width: 640px) {
  .sm\:pt-0 {
    padding-top: 0
  }
  .sm\:pb-0 {
    padding-bottom: 0
  }
}
  .manufacturer-toggle{
    background:#fff;
    cursor:pointer;
    input{
      position:absolute;
      top:0;
      left:0;
      margin:0;
      width:100%;
      height:100%;
      opacity:0;
      z-index:10;
      &:checked + div{
        opacity:1;
      }
    }
    div{
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      opacity:0;
      transition:.2s ease-in-out;
      border:2px solid #0a70e3;
    }
  }

  .text-black {
    color: black !important;
  }

  .leaseOptionDrops {
    display: flex
  }

  .leaseOptionDrops > div {
    flex: 50%;
    display: flex;
    padding: 0 15px;
  }

  .leaseOptionDrops > div > div {
    flex: 50%;
  }

  @media(max-width: 1150px) {
    .leaseOptionDrops > div > div {
      flex: 100%;
    }
    .leaseOptionDrops > div {
      flex-wrap: wrap;
    }
    .prcheOptn > .frmInline > label {
      margin-right: 0;
      display: block;
      margin-bottom: 15px
    }
    .prcheOptn > .frmInline > label + span {
      padding-left: 0
    }
  }

  @media(max-width: px) {
    .prcheOptn > .frmInline {
      padding-bottom: 0
    }
  }

  .header-like-para {
    font-size: 1.8rem !important;
    color: #0a70e3 !important;
  }

  img.stamps {
    width: 100px !important;
  }

  .red-text {
    font-size: 18px;
    color: #b50a78;
    font-weight: bold;
  }

  .blue-text {
    font-size: 18px;
    color: #2B72DC;
    font-weight: bold;
  }

  .results table {
    .image img {
      display: block;
      width: 195px;
      height: auto;
    }

    .star-holder {
      justify-content: center;
      display: flex;
      font-size: 0;
      margin-bottom: 5px
    }

    .options__split > div:first-of-type {
      width: 40%;
    }

    .options__split > div:last-of-type {
      width: 60%;
    }

    iframe {
      height: 244px;
    }
  }

  @media screen and (max-width: 767px) {
    .results.desktop {
      display: none;
    }
  }

  /* RESULTS MOBILE */
  .results-mobile {

    @media screen and (min-width: 768px) {
      display: none;
    }

    // potential-savings
    .potential-savings {
      padding: 10px 20px;
      border: 1px solid #ccc;
      text-align: center;
      line-height: 1.2;
      font-size: 20px;
      font-weight: 700;
      color: #959595;
    }

    // location
    .location {
      margin-top: 15px;
      padding: 10px 20px;
      border: 2px solid #ccc;
      background-color: #f4f4f4;
      text-align: center;
      line-height: 1.4;
      font-size: 14px;
      font-weight: 700;
      color: #959595;

      span {
        font-weight: 400;
      }
    }

    /* offer */
    .offer {
      margin-top: 30px;

      &:not(.first) {
        padding-top: 30px;
        border-top: 1px solid #f4f4f4;
      }

      // title
      .offer-title {
        display: block;
        padding: 10px 20px;
        text-align: center;
        line-height: 1.3;
        font-size: 15px;
        font-weight: 700;
        color: #fff;

        &.blue {
          background-color: #0b70e4;
        }

        &.red {
          background-color: #b50a78;
        }
      }

      /* table */
      .offer-table {
        width: 100%;
        th, td {
          vertical-align: middle;
          border-left: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          text-align: center;
          line-height: 1.2;
          font-size: 10px;
          color: #959595;

          &:last-child {
            border-right: 1px solid #ccc;
          }

          &.empty {
            border: none !important;
            background-color: transparent !important;

            &:last-child {
              border-left: 1px solid #ccc !important;
            }
          }

          &.big {
            // line-height: 1.1;
            // font-size: 12px;
            // font-weight: 700;
          }
        }

        th {
          padding: 5px;
          background-color: #f4f4f4;
          font-weight: 700;
        }

        td {
          padding: 10px 5px;
        }

        strong {
          font-weight: 700;
        }

        // separator
        .separator {
          margin: 10px -5px;
          height: 1px;
          background-color: #ccc;
        }

        // image
        .image {
          img {
            display: block;
            margin: 0 auto 5px;
            max-width:100%;
          }
        }

        // stars
        .star-holder {
          justify-content: center;
          i:nth-child(5) ~ i{
            display:none
          }
          i:after{
            display:block !important;
            width: 6px;
            left: 5px;
          }
        }
      }

      /* errors */
      .offer-errors {
        margin-top: 15px;

        // manufacturer-logo
        .manufacturer-logo {
          display: block;
          margin: 0 auto;
          max-width: 100%;
        }

        // warning
        .warning {
          display: flex;
          align-items: center;
          margin-top: 15px;

          img {
            margin-right: 10px;
            width: 30px;
          }

          .red-text {
            line-height: 1.2;
            font-size: 15px;
          }
        }

        .blue-text {
          margin-top: 15px;
          text-align: center;
          line-height: 1.2;
          font-size: 15px;
        }
      }

      /* info */
      .offer-info-wrapper {
        position: relative;
        margin-top: 25px;
        padding: 15px 10px;
        border: 1px solid #ccc;

        &:after {
          position: absolute;
          top: -11px;
          left: calc(50% - 10px);
          border-left: solid 10px transparent;
          border-right: solid 10px transparent;
          border-bottom: solid 10px #ccc;
          content: '';
        }
      }

      .offer-info {
        display: flex;
        align-items: center;
        line-height: 1.3;
        font-size: 12px;

        &:not(:first-child) {
          margin-top: 15px;
        }

        img {
          margin-right: 10px;
          width: 20px;
        }
      }

      /* buttons */
      .offer-buttons {
        margin-top: 15px;
        margin-bottom: 15px;

        a {
          display: block;
          background: linear-gradient(45deg, #0a70e3, #b50a78);
          color: #fff;
          width: auto !important;
          border-radius: 0;
          cursor: pointer;
          border-radius: .3125rem;
          font-size: 1.65625rem;
          padding: 1.25rem 2.6rem;
          text-align: center;
          box-shadow: 0 4px 22.56px 1.44px rgba(0, 0, 0, .3);
          text-decoration: none;
          font-weight: 700;

          &:not(:first-child) {
            margin-top: 10px;
          }

          &.red {
            padding: 10px;
            background-color: #db1256;
          }

          &.blue {
            background-color: #0b70e4;
          }
        }
      }
    }

    /* more-info */
    .more-info {
      position: relative;
      margin-top: 25px;
      overflow-x: visible !important;

      &:after {
        position: absolute;
        top: -10px;
        left: calc(50% - 10px);
        border-left: solid 10px transparent;
        border-right: solid 10px transparent;
        border-bottom: solid 10px #ccc;
        content: '';
      }

      .options__split {
        display: block;

        > div:first-of-type {
          padding: 0;
          width: 100%;
        }

        > div:last-of-type {
          margin-top: 15px;
          padding: 0;
          width: 100%;
        }
      }

      .options .optionsPanel--withSide {
        margin-bottom: 20px !important;
        padding: 20px !important;
      }

      .results__table {
        overflow: visible;
      }

      .results__table > table > tr > td:first-child {
        display: none;
      }

      table {
        table-layout: fixed;
        width: 100%;
      }

      table th.options, table td.options {
        padding: 0 !important;
        border: none !important;
      }
    }
  }
</style>

<style scoped lang="scss">
  .fullText > .in {
    width: 100%;
    max-width: 75rem;
  }

  .btn--blockPrimary span:after {
    display: none;
  }

  @media screen and (max-width: 1023px) {
    .frmInline > div {
      width: 100% !important;
    }

    .cmpreRslt .benefits__forms .formElem__block {
      width: 50%;
    }

    .btn--blockPrimary {
      padding: 1rem 2rem;
      font-size: 1rem;
    }

    .results {
      overflow-x: scroll;
    }

    .results table td.rotate div {
      font-size: 20px !important;
    }

    .results table th h5 {
      font-size: 1rem;
    }

    .results table th {
      font-size: 0.75rem;
    }

    .results table th.large {
      display: table-cell;
      margin-bottom: 0;
      font-size: 1rem;
    }

    .results table th.highlightRow, .results table td.highlightRow {
      font-size: 1.5rem;
    }

    .results table td.image img {
      max-width: 100px;
    }

    .results table th.largeText, .results table td.largeText {
      font-size: 1.25rem;
    }
  }

  @media screen and (max-width: 568px) {
    .prcheOptn, .lesetrmOptn {
      width: 100%;
    }

    .mnfctrSlct {
      background-color: #CCC;
    }
    .mnfctrSlct li {
      background-color: #FFF;
    }

    .mnfctrSlct .formElem__block .inputElem ul {
      display: flex;
      flex-wrap: wrap;
      margin-left: -5px;
      margin-right: -5px;
    }

    .cmpreRslt .benefits__forms .formElem__block {
      width: 100%;
    }

    .mnfctrSlct .inputElem ul li {
      flex: 0 0 calc(50% - 10px);
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 5px;
      width: auto;
    }
  }

  .results-advanced-options-button {
    float: left;
    padding-top: 10px;
  }

  .results-advanced-options-button span {
    position: relative;
    font-size: 1.4rem;
    line-height: 30px;
    color: #363636;
    cursor: pointer;
  }

  .results-advanced-options-button i {
    margin-left: 15px;
    font-size: 14px;
  }

  .results-reset-options-button {
    float: right;
    padding-right: 10px;
  }

  .results-reset-options-button div {
    background-color: rgb(43, 114, 220);
    padding: 15px 30px;
    margin-left: 10px;
    color: white;
    cursor: pointer;
    font-size: 18px
  }

  @media(max-width: 450px) {
    .results-advanced-options-button {
      float: none;
      text-align: center;
    }
    .results-reset-options-button {
      max-width: 200px;
      float: none;
      margin: 0 auto 10px auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Results/Index.vue